<!-- Contact Section : template repris de SectionContact.vue pour pouvoir afficher la référence Ovatio  (ClientId) non supportée par le générateur -->
<template>
  <v-form ref="CONTACT" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="CONTACT">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <civilite-select v-if="isDisplayed('CIVILITE_ID')"
                         ref="CIVILITE_ID"
                         :theme="theme"
                         :showMissing="showMissing"
                         v-model:value=civiliteId
                         :contact=contact
                         :moduleId=moduleId
                         libelle="'Civilité'"
                         newLabel=''
                         selectText=""
                         @status=statusCiviliteId
                         :requiredAttributs="requiredAttributs"
                         :autoSelect=true
                         :ressource=ressourceCiviliteSelect
                         :filters=civiliteIdFilter
                         :toggleReset=resetCiviliteId
                         :required="isRequired('CIVILITE_ID')"
                         :contextId=contact.id
                         :readOnly="readOnly('CIVILITE_ID')"
                         :objType=objType
                         :fiche=fiche
                         :sectionName="sectionName">
        </civilite-select>
        <contact-prenom v-if="isDisplayed('PRENOM')"
                        ref="PRENOM"
                        :theme="theme"
                        :showMissing="showMissing"
                        v-model:value=prenom
                        :min="3"
                        :max="25"
                        @status=statusPrenom
                        :over-ride-placeholder=placeholderPrenom
                        :required="isRequired('PRENOM')"
                        :contextId=contact.id
                        :readOnly="readOnly('PRENOM')"
                        :objType=objType
                        :fiche=fiche
                        :sectionName="sectionName">
        </contact-prenom>
        <contact-nom v-if="isDisplayed('NOM')"
                     ref="NOM"
                     :theme="theme"
                     :showMissing="showMissing"
                     v-model:value=nom
                     :min="3"
                     :max="25"
                     @status=statusNom
                     :over-ride-placeholder=placeholderNom
                     :required="isRequired('NOM')"
                     :contextId=contact.id
                     :readOnly="readOnly('NOM')"
                     :objType=objType
                     :fiche=fiche
                     :sectionName="sectionName">
        </contact-nom>
        <contact-mail v-if="isDisplayed('MAIL')"
                      ref="MAIL"
                      :theme="theme"
                      :showMissing="showMissing"
                      v-model:value=mail
                      @status=statusMail
                      :over-ride-placeholder=placeholderMail
                      :required="isRequired('MAIL')"
                      :contextId=contact.id
                      :readOnly="readOnly('MAIL')"
                      :objType=objType
                      :fiche=fiche
                      :sectionName="sectionName">
        </contact-mail>
        <contact-numero v-if="isDisplayed('NUMERO')"
                        ref="NUMERO"
                        :theme="theme"
                        :showMissing="showMissing"
                        v-model:value=numero
                        @status=statusNumero
                        :required="isRequired('NUMERO')"
                        :contextId=contact.id
                        :readOnly="readOnly('NUMERO')"
                        :objType=objType
                        :fiche=fiche
                        :sectionName="sectionName">
        </contact-numero>
        <qualite-select v-if="isDisplayed('QUALITE_ID')"
                        ref="QUALITE_ID"
                        :theme="theme"
                        :showMissing="showMissing"
                        v-model:value=qualiteId
                        :contact=contact
                        :moduleId=moduleId
                        libelle="'Qualité'"
                        newLabel=''
                        selectText=""
                        @status=statusQualiteId
                        :requiredAttributs="requiredAttributs"
                        :autoSelect=true
                        :ressource=ressourceQualiteSelect
                        :filters=qualiteIdFilter
                        :toggleReset=resetQualiteId
                        :required="isRequired('QUALITE_ID')"
                        :contextId=contact.id
                        :readOnly="readOnly('QUALITE_ID')"
                        :objType=objType
                        :fiche=fiche
                        :sectionName="sectionName">
        </qualite-select>
        <edit-info v-if="showRefOvatio"
           ref="REF_OVATIO"
           :context-id="editContact.id"
           :value="editContact.clientId"
           :libelle="'Référence Ovatio'"
           :read-only="true"
           :hide-label="false">
        </edit-info>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>
<script lang="ts">
  import DialogHubManager from '@/framework/dialog/helpers/DialogHubManager';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import Contact from '@/generated/classes/Contact';
  import { RessourceGenSection, GenSection } from '@/generated/ressources/generatedRessources';
  import SectionContact from '@/generated/sections/SectionContact.vue';
  import { storeSession, storeContact } from '@/generated/stores';
  import UserProfile, { EnumProfile } from "@/framework/base/classes/UserProfile";
  import Owner from '@/extend/classes/Owner';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import { defineComponent } from "vue";
  import { FieldStatus, SectionStatus } from '@/framework/base/components/FieldInfo';
  import EditInfo from '@/framework/base/components/EditInfo.vue';

  export default defineComponent({
    components: { EditInfo},
    extends: SectionContact,
    props: {
      contextId: {
        type: Number
      }
    },
    data() {
      return {
        status: new SectionStatus(false, false, false),
      }
    },
    mounted() {
      DialogHubManager.waitAnswer('cancelSignataire', this.cancelSignataire);
      if (this.fiche == Fiches.SALARIE) {
        DialogHubManager.waitAnswer('createSalarie', this.createSalarie);
      }
    },
    computed: {
      contratId(): number {
        if (this.contextId) {
          return this.contextId;
        } else {
          return 0;
        }
      },
      showRefOvatio(): boolean {
        const user = storeSession.connectedUser;
        if (!user) {
          return false;
        }
        // Utilisateur interne Ovatio : le marqueur interne peut être porté
        // par profil (compte) ou currentProfil (session en cours d'impersonation).
        const interne = ((user.profil | user.currentProfil) & UserProfile.userInterne) > 0;
        // Connecté en tant qu'employeur : rôle actif = client.
        const employeur = UserProfile.hasProfile(user, EnumProfile.client);
        return interne && employeur;
      },
      isSalarie(): boolean {
        let res = false;
        const user = storeSession.connectedUser;
        if (user) {
          res = UserProfile.hasProfile(user, EnumProfile.salarie);
        }
        return res;
      },
      ressource() {
        return RessourceGenSection(GenSection.CONTACT);
      },
      fields(): string[] {
        return ['PRENOM', 'NOM', 'MAIL', 'NUMERO', 'IDENTIFIANT', 'ADRESSE_ID', 'QUALITE_ID', 'IS_SIGNATAIRE', 'PERSO', 'REF_CLIENT'];
      }
    },
    methods: {
      cancelSignataire(obj: unknown) {
        const contact = obj as Contact;
        this.updated = true;
        const sContact = storeContact.getContact(contact.id);
        if (sContact) {
          sContact.fromContact(contact);
        }
      },
      createSalarie(obj: unknown) {
        const contact = obj as Contact;
        this.editContact = storeContact.getContact(contact.id);
        this.$emit('updated', this.editContact);
      },
      fieldUpdated(field: string, value: unknown): void {
        if (field == "MAIL") {
          this.readOnlyMap.set("NUMERO", this.editContact.isUser && this.cloneContact.mail != this.editContact.mail);
        } else if (field == "NUMERO") {
          this.readOnlyMap.set("MAIL", this.editContact.isUser > 0 && this.cloneContact.numero != this.editContact.numero);
        }
      },
      readOnly(value: string): boolean {
        let res = false;
        if (!this.editContact.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("CIVILITE_ID", false);
          this.readOnlyMap.set("PRENOM", false);
          this.readOnlyMap.set("NOM", false);
          this.readOnlyMap.set("MAIL", false);
          this.readOnlyMap.set("NUMERO", false);
          this.readOnlyMap.set("IDENTIFIANT", false);
          this.readOnlyMap.set("QUALITE_ID", false);
          this.readOnlyMap.set("IS_SIGNATAIRE", false);
          this.readOnlyMap.set("PERSO", false);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },
      isDisplayed(value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
          const isRepresentant = this.fromSection == Sections.ETABLISSEMENT_CONTACTS ||
            this.fromSection == Sections.ETABLISSEMENT_REPRESENTANT;
          const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("CIVILITE_ID", this.fromSection != 'CONNEXION');
          this.displayMap.set("PRENOM", true);
          this.displayMap.set("NOM", true);
          this.displayMap.set("MAIL", isRepresentant || this.requiredMissing(requiredAttributs, "MAIL") || (!this.showIdentifiant() && !!this.fiche));
          this.displayMap.set("NUMERO", isRepresentant || this.requiredMissing(requiredAttributs, "NUMERO") || (!this.showIdentifiant() && !!this.fiche));
          this.displayMap.set("IDENTIFIANT", this.requiredMissing(requiredAttributs, "IDENTIFIANT") || (this.showIdentifiant() && this.editContact.id < 0 && (!!this.fiche || this.fromSection == 'CONNEXION')));
          this.displayMap.set("QUALITE_ID", isRepresentant || this.requiredMissing(requiredAttributs, "QUALITE_ID") || (
            (this.fromSection == Sections.ETABLISSEMENT_REPRESENTANT ||
              ((this.fiche == Fiches.PROFIL || this.fiche == undefined) &&
                !this.isSalarie &&
                this.fromSection != Sections.CONTRAT_SALARIE &&
                this.fromSection != Sections.CONNEXION)) &&
            !!this.fiche));
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },
      isRequired(value: string): boolean {
        let res = true;
        if (this.requiredMap.size == 0) {
          const isRepresentant = this.fromSection == Sections.ETABLISSEMENT_CONTACTS ||
            this.fromSection == Sections.ETABLISSEMENT_REPRESENTANT;
          const requiredAttributs = this.getRequiredAttributs();
          this.requiredMap.set("CIVILITE_ID", isRepresentant || this.requiredMissing(requiredAttributs, "CIVILITE_ID") || !this.fiche);
          this.requiredMap.set("PRENOM", true);
          this.requiredMap.set("NOM", true);
          this.requiredMap.set("MAIL", isRepresentant || this.requiredMissing(requiredAttributs, "MAIL") || (this.fromSection != Sections.ETABLISSEMENT_CONTACTS && !this.fiche));
          this.requiredMap.set("NUMERO", isRepresentant || this.requiredMissing(requiredAttributs, "NUMERO") || (this.fromSection != Sections.ETABLISSEMENT_CONTACTS && !this.fiche));
          this.requiredMap.set("IDENTIFIANT", true);
          this.requiredMap.set("QUALITE_ID", isRepresentant || this.requiredMissing(requiredAttributs, "QUALITE_ID") || (this.fromSection == Sections.ETABLISSEMENT_CONTACTS && !this.fiche));
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },
      showIdentifiant(): boolean {
        return this.editContact.id < 0 &&
          (this.fromSection == Sections.CONNEXION ||
            this.fromSection == Sections.CONTRAT_SALARIE ||
            this.fiche == Fiches.PROFIL ||
            this.fiche == Fiches.SALARIE);
      },
      picto(): string {
        return 'SectionPictoContact'
      },
      sectionSave(): void {
        // TO CHECK
        if (this.checkFields()) {
          if (this.fromSection == Sections.CONNEXION) {
            // this.editContact.isUser = true;
            if (this.editContact.valid) {
              this.editContact.verify = false;
            } else {
              this.editContact.verify = true;
            }
          }

          if (this.fromSection == Sections.CONTRAT_SALARIE) {
            // this.editContact.isSalarie = true;
            // this.editContact.isUser = false;

            this.editContact.owner = new Owner();
            this.editContact.owner.objType = ObjTypes.CONTRAT;
            this.editContact.owner.objId = this.contratId;
          }

          // if (this.fiche == Fiches.SALARIE) {
          //   this.editContact.isSalarie = true;
          //   this.editContact.isUser = false;
          // }
          //this.save();
          this.saving = true;
          Contact.save(this.editContact).then((res) => {
            this.updated = false;
            this.readOnlyMap.set("NUMERO", false);
            this.readOnlyMap.set("MAIL", false);
            this.$emit('updated', res);
            this.$emit('closeDialog');
          });
        }
      }
    }
  })

</script>
